import React, { PropsWithChildren } from "react";

interface BadgeProps extends PropsWithChildren {}

const CSS_CLASS_NAME = "c-badge";

const Badge = (props: BadgeProps) => {
    const { children } = props;
    return <span className={CSS_CLASS_NAME}>{children}</span>;
};

export default Badge;
